import { SignedURLDTO, UrlDTO } from 'models/visuals'

import { StatusResponse } from 'models/redux'
import { UploadType } from 'components/common/FileAPI/fileUtils'
import { VisualFileType } from 'constants/visual'
import { VisualUploadEndpoints } from 'constants/API'
import constate from 'constate'
import { useFileAPI } from 'components/common/FileAPI'
import { useState } from 'react'

/** Enum of all upload visuals types */
export enum UploadVisualsTypes {
  AI_EDITING = 'AI_EDITING',
  ORIGINAL_STATE = 'ORIGINAL_STATE',
}

export const [ClientPropertySelfUploadPopupContext, useClientPropertySelfUploadPopup] = constate(({ assignmentId }: { assignmentId: string }) => {

  const [uploadVisualsType, setUploadVisualsType] = useState<UploadVisualsTypes>(UploadVisualsTypes.ORIGINAL_STATE)

  // TODO: Update when the API is ready
  const fileCtrl = useFileAPI('UPLOAD_VISUALS_IN_GALEERY', {
    uploadUrlResolver: (entry, api) => api.post<SignedURLDTO>(
      VisualUploadEndpoints.GET_UPLOAD_URL,
      { assignmentId },
      {
        filename: entry.fileObject.name,
        contentType: entry.fileObject.type,
        type: VisualFileType.RAW,
      },
      true,
      {
        params: {
          uploadType: UploadType.RESUMABLE
        }
      }
    ),
    reUploadUrlResolver: (entry, api) => api.post<SignedURLDTO>(
      VisualUploadEndpoints.GET_UPLOAD_URL,
      { assignmentId },
      {
        filename: entry.fileObject.name,
        contentType: entry.fileObject.type,
        type: VisualFileType.RAW,
      },
      true,
      {
        params: {
          uploadType: UploadType.RESUMABLE
        }
      }
    ),
    loadUrlResolver: (entry, api) => api.post<UrlDTO>(
      VisualUploadEndpoints.GET_LOAD_URL,
      {
        assignmentId,
        filename: entry.gcFilename!,
      },
      {},
      true,
      {
        params: {
          type: VisualFileType.RAW_THUMB
        }
      }
    ),
    deleteHandler: (entry, api) => api.delete<StatusResponse>(
      VisualUploadEndpoints.DELETE,
      {
        assignmentId,
        filename: entry.gcFilename!,
      },
      true,
      {
        params: {
          type: VisualFileType.RAW
        }
      }
    )
  })

  return {
    fileCtrl,
    uploadVisualsType,
    setUploadVisualsType
  }
})
